function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHumanCapital(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 8.777,
    y: 152.989,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -75.2439 140.3239)",
    style: {
      fill: "#999999"
    },
    width: 245.974,
    height: 16
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E21B1B"
    },
    points: "255.968,36.784 190.128,54.424 238.328,102.624 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.272,
    y: 359.01,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -138.766 399.0082)",
    style: {
      fill: "#999999"
    },
    width: 245.982,
    height: 16
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E21B1B"
    },
    points: "288.032,491.216 353.872,473.576 305.672,425.376 "
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#BBBBBB"
    },
    cx: 82.76,
    cy: 371.76,
    r: 41.384
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M80.92,512l-39.536-86.44c0,0-41.384,0.92-41.384,38.624V512H80.92z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M84.6,512l39.544-86.44c0,0,41.384,0.92,41.384,38.624V512H84.6z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E21B1B"
    },
    points: "53.84,425.56 82.76,489.928 111.68,425.56 "
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#BBBBBB"
    },
    cx: 429.24,
    cy: 41.384,
    r: 41.384
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M427.4,181.664L387.856,95.2c0,0-41.384,0.92-41.384,38.624v47.816L427.4,181.664z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M431.08,181.664L470.616,95.2c0,0,41.384,0.944,41.384,38.648v47.816H431.08z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E21B1B"
    },
    points: "400.32,95.224 429.24,159.592 458.16,95.224 "
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#BBBBBB"
    },
    cx: 256,
    cy: 206.552,
    r: 41.384
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M254.16,346.832l-39.544-86.44c0,0-41.384,0.92-41.384,38.624v47.816H254.16z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M257.84,346.832l39.544-86.44c0,0,41.384,0.92,41.384,38.624v47.816H257.84z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E21B1B"
    },
    points: "227.08,260.392 256,324.76 284.92,260.392 "
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumanCapital);
export default __webpack_public_path__ + "static/media/human-capital.3772ba64ef274995ffcb47873de1530d.svg";
export { ForwardRef as ReactComponent };